import { List } from "../Components/index.js";

export default [
    {
        path: "/criminal-list",
        component: () => import("../Components/List.vue"),
        name: "criminal-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/criminal/create",
        component: () => import("../Components/Create.vue"),
        name: "criminal-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/criminal/:id/edit",
        component: () => import("../Components/Edit.vue"),
        name: "criminal-edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/criminal/:id",
        component: () => import("../Components/View.vue"),
        name: "criminal-view",
        meta: {
            requiresAuth: true,
        },
    },
];
